import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyPreferenceEntity } from './company-preference.entity';
import { PreferenceRbacRoleEntity } from './preference-rbac-role.entity';
import { PreferenceSetDefaultEntity } from './preference-set-default.entity';
import { PreferenceUserEntity } from './preference-user.entity';
import { PreferenceEntity } from './preference.entity';
import { TeamPreferenceEntity } from './team-preference.entity';

@Index('_fk__preference__id', ['fkPreferenceId'], {})
@Entity('_preference_set')
export class PreferenceSetEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__preference__id',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceId!: number | null;

	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('longtext', { name: '_value', nullable: true })
	public value!: string | null;

	@OneToMany(
		() => PreferenceRbacRoleEntity,
		(preferenceRbacRole) => preferenceRbacRole.fkPreferenceSetIdDefault2,
		{},
	)
	public preferenceRbacRoles!: Array<PreferenceRbacRoleEntity>;

	@ManyToOne(
		() => PreferenceEntity,
		(preference) => preference.preferenceSets,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__preference__id', referencedColumnName: 'id' }])
	public fkPreference!: PreferenceEntity;

	@OneToMany(
		() => PreferenceSetDefaultEntity,
		(preferenceSetDefault) => preferenceSetDefault.fkPreferenceSet,
		{},
	)
	public preferenceSetDefaults!: Array<PreferenceSetDefaultEntity>;

	@OneToMany(
		() => PreferenceUserEntity,
		(preferenceUser) => preferenceUser.fkPreferenceSetIdDefault2,
		{},
	)
	public preferenceUsers!: Array<PreferenceUserEntity>;

	@OneToMany(
		() => CompanyPreferenceEntity,
		(companyPreference) => companyPreference.fkPreferenceSetIdDefault2,
		{},
	)
	public companyPreferences!: Array<CompanyPreferenceEntity>;

	@OneToMany(
		() => TeamPreferenceEntity,
		(teamPreference) => teamPreference.fkPreferenceSetIdDefault2,
		{},
	)
	public teamPreferences!: Array<TeamPreferenceEntity>;
}
